module.exports = __webpack_public_path__ + "static/media/image15.ce3701a0.JPG";